import type { LanguageCode } from '@/interfaces';
import { getMasterTranslationLanguageCode } from '@/utils';
import { umsFetcher } from './base.fetchers';

type UpdateTrackedShipments = (arg: {
  language: LanguageCode;
  uuids: string[];
}) => Promise<number | undefined>;

export const updateTrackedShipments: UpdateTrackedShipments = async ({ language, uuids }) => {
  if (!uuids.length) return;

  try {
    const response = await umsFetcher.post('users/shipment', {
      uuids,
      language: getMasterTranslationLanguageCode(language),
    });

    return response.status;
  } catch (err: any) {
    console.error('users/shipment ', err);
  }
};
